import { normalizeKenyaMobile } from '@/utils/paValidation';

export const AGENT_EMAIL_MESSAGE = "Customer email cannot be the same as the agent's email address";
export const AGENT_PHONE_MESSAGE = "Customer phone cannot be the same as the agent's phone number";

function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase();
}

function agentEmail(agentUser) {
  return normalizeEmail(agentUser?.email || agentUser?.attributes?.email);
}

function agentPhone(agentUser) {
  return normalizeKenyaMobile(
    agentUser?.phone_number || agentUser?.mobileNumber || agentUser?.['custom:phone'] || '',
  );
}

/** True when the customer email is the signed-in agent's own email. */
export function isAgentEmail(email, agentUser) {
  const own = agentEmail(agentUser);
  return !!own && normalizeEmail(email) === own;
}

/** True when the customer phone is the signed-in agent's own phone, in any Kenyan format. */
export function isAgentPhone(phone, agentUser) {
  const own = agentPhone(agentUser);
  return !!own && normalizeKenyaMobile(phone) === own;
}

/** First agent-contact error for the given customer email/phone, or '' when neither matches. */
export function agentContactError({ email, phone }, agentUser) {
  if (isAgentEmail(email, agentUser)) return AGENT_EMAIL_MESSAGE;
  if (isAgentPhone(phone, agentUser)) return AGENT_PHONE_MESSAGE;
  return '';
}
